import { usePage } from '@inertiajs/react';
import { Box, Container, Typography, Paper } from '@mui/material';
import AdminRenterCard from '../../components/admin/AdminRenterCard';

interface ProspectData {
    id: string;
    name: string;
    phone_number: string | null;
    created_at: string;
    search_status: string;
    move_in_date_requested: string | null;
    budget: number | null;
    tour_requests_count: number;
    upcoming_tours_count: number;
    next_tour: {
        date: string;
        time: string;
        address: string;
    } | null;
}

interface Props {
    full_customers: ProspectData[];
    came_via_landlord: ProspectData[];
    full_customers_count: number;
    came_via_landlord_count: number;
    [key: string]: any;
}

export default function AdminRentersPage() {
    const { props } = usePage<Props>();
    const { full_customers, came_via_landlord, full_customers_count, came_via_landlord_count } = props;

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            {/* Page Title */}
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 4 }}>
                Admin Renters
            </Typography>

            {/* Full Customers Section */}
            <Paper
                elevation={0}
                sx={{
                    mb: 4,
                    p: 3,
                    bgcolor: 'success.light',
                    borderRadius: '8px',
                    border: '2px solid',
                    borderColor: 'success.main'
                }}
            >
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: 'success.dark' }}>
                    Full Customers
                </Typography>
                <Typography variant="body1" sx={{ mb: 3, color: 'success.dark' }}>
                    {full_customers_count} {full_customers_count === 1 ? 'prospect' : 'prospects'} with budget
                </Typography>
                <Box>
                    {full_customers.length > 0 ? (
                        full_customers.map((prospect) => (
                            <AdminRenterCard
                                key={prospect.id}
                                prospect={prospect}
                                isFullCustomer={true}
                            />
                        ))
                    ) : (
                        <Typography variant="body2" color="text.secondary">
                            No full customers found
                        </Typography>
                    )}
                </Box>
            </Paper>

            {/* Came via Landlord Section */}
            <Paper
                elevation={0}
                sx={{
                    mb: 4,
                    p: 3,
                    bgcolor: 'grey.100',
                    borderRadius: '8px',
                    border: '2px solid',
                    borderColor: 'grey.300'
                }}
            >
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: 'grey.700' }}>
                    Came via Landlord
                </Typography>
                <Typography variant="body1" sx={{ mb: 3, color: 'grey.700' }}>
                    {came_via_landlord_count} {came_via_landlord_count === 1 ? 'prospect' : 'prospects'} without budget
                </Typography>
                <Box>
                    {came_via_landlord.length > 0 ? (
                        came_via_landlord.map((prospect) => (
                            <AdminRenterCard
                                key={prospect.id}
                                prospect={prospect}
                                isFullCustomer={false}
                            />
                        ))
                    ) : (
                        <Typography variant="body2" color="text.secondary">
                            No prospects found
                        </Typography>
                    )}
                </Box>
            </Paper>
        </Container>
    );
}

